<template>
    <div>
        <v-menu
            v-if                    = "sites.length > 1"
            v-model                 = "show"
            content-class           = "white"
            max-height              = "calc(100% - 104px)"
            nudge-top               = "-4"
            :close-on-content-click = "false"
            offset-y
            z-index="901"
            style="border-radius: 10px!important;"
        >
            <template v-slot:activator="{ on, attrs }">
                <div

                    v-bind = "attrs"
                    v-on   = "on"
                    class  = "v-flex"
                >
                    <div
                        v-for  = "(site, idx) in maxsites"
                        :key   = "site.id"
                        class  = "site-box white"
                        :style = "boxsize"
                    >
                        <div v-if="idx === index" class="site-indicator"></div>
                    </div>
                    <div v-if="stepUnits && stepUnits.length > 5">
                        <i class="fas fa-ellipsis-h" :class="index >= maxsites.length ? 'orange--text' : 'white--text'"></i>
                    </div>
                </div>
            </template>

            <p-inc-navigation-entries
                :incident = "incident"
                :sites    = "stepUnits"
                :step     = "step"
                @select   = "onSelect"
                @remove   = "onRemove"
            />
        </v-menu>
    </div>
</template>

<script>

import Inc                   from "@/modules/inc/service/Inc";
import PIncNavigationEntries from "@/modules/inc/steps/components/navigation/private/PIncNavigationEntries.vue";

export default {
    name: "PIncNavigationMenu",

    components: {
        PIncNavigationEntries,
    },

    props: {
        stepUnits: {

        },

        step: {

        }
    },

    data: () => ({
        show: false,
        size: 18,
    }),

    computed: {
        incident () {
            return this.$store.getters.incident;
        },

        sites () {
            return this.incident.sites;
        },

        maxsites () {
            if (!this.stepUnits) {
                return [];
            }

            if (this.stepUnits.length > 5) {
                return this.stepUnits.slice(0, 5);
            }

            return this.stepUnits;
        },

        boxsize () {
            return Inc.style.box(this.size);
        },

        selected () {
            return this.$store.getters.context.site;
        },

        index () {
            return this.stepUnits.findIndex (u => u.id === this.selected);
        }
   },

    watch: {
        show () {
            if (this.show) {
                this.$bus.$emit(this.$incident.events.navigate);
            }
        },
    },

    methods: {
        onSelect (unit) {
            this.show = false;
            this.$emit("select", unit);
        },

        onRemove (unit) {
            this.$emit("remove", unit);
        },
    }
}
</script>

<style scoped>

.site-box {
    margin-right: 3px;
    border-radius: 2px;
    margin-top: 2px;
}

.site-indicator {
    background-color: orange;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-left: 3px;
    margin-top: 3px;
}

.v-menu__content {
    border-radius: 10px;
}

</style>